import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useRegistration } from './RegistrationContext';
import StepIndicator from './StepIndicator';
import AddressInput from '../common/AddressInput';
import MainLayout from '../common/MainLayout';

function AddressDetails() {
  const navigate = useNavigate();
  const { registrationData, updateRegistrationData } = useRegistration();

  const handleSubmit = e => {
    e.preventDefault();
    navigate('/membership/type');
  };

  return (
    <MainLayout>
      <StepIndicator currentStep={2} />

      <h2 className="text-2xl font-bold mb-8 text-hdlcc-textPrimary tracking-tight">
        Address Details
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <AddressInput value={registrationData} onChange={updateRegistrationData} />

        <div className="mt-8 flex justify-between">
          <button
            type="button"
            onClick={() => navigate('/membership')}
            className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 text-white px-8 py-3 rounded-xl hover:bg-hdlcc-gray transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Previous
          </button>
          <button
            type="submit"
            className="bg-gradient-to-r from-hdlcc-primary to-hdlcc-primaryLight text-white px-8 py-3 rounded-xl hover:shadow-glow-primary transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Next: Membership Details
          </button>
        </div>
      </form>
    </MainLayout>
  );
}

export default AddressDetails;
